module.exports = __webpack_public_path__ + "static/media/event.c9d47217.svg";